import React, { useEffect, useState } from "react";
import Table, { AvatarCell, SelectColumnFilter, StatusPill, ImageCell } from "./Table"; // new

function TableData() {
  const data = [
    {
      id: "1",
      number: "123-xzy",
      name: "2 X 4M Stagging",
      version: "1.2",
      stock: "df",
    },
    {
      id: "2",
      number: "123-xzy",
      name: "Electric Foot",
      version: "1.2",
      stock: "df",
    },
    {
      id: "3",
      number: "123-xzy",
      name: "5 axis CNC",
      version: "1.2",
      stock: "df",
    },
    {
      id: "4",
      number: "123-xzy",
      name: "Massage Chair",
      version: "1.2",
      stock: "df",
    },
  ];

  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
      },
      {
        Header: "Number",
        accessor: "number",
      },
      {
        Header: "Item Name",
        accessor: "name",
      },
      {
        Header: "Image",
        accessor: "image",
        Cell: ImageCell,
      },
      {
        Header: "Version",
        accessor: "version",
      },
      {
        Header: "QTY in Stock",
        id: "edit",
        accessor: "stock",
        Cell: (value) => (
          <button>
          <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L14 14M1 14L14 1" stroke="#E40000" stroke-width="2"/>
          </svg>
          </button>
        ),
      },
      {
        Header: "",
        id: "editbutton",
        accessor: "stockrestore",
        Cell: (value) => (
          <button
                type="button"
                class="py-2 px-4 border border-gray-300  text-sm font-medium text-blue-900 rounded-2xl mr-4 bg-white hover:bg-blue-200 hover:text-white focus:z-10 focus:ring-2  focus:bg-white focus:text-black focus:shadow-lg focus:shadow-slate-400  "
              >
                Restore
              </button>
        ),
      },
    ],
    []
  );

  return (
    <div className="mb-8 pb-4">
      <main className="max-w-full min-h-full px-4 sm:px-6 lg:px-8 pt-4">
        <div className="-mt-10">
          <Table
            columns={columns}
            data={data == undefined ? [] : data}
            text="Undefined"
          />
        </div>
      </main>
    </div>
  );
}

export default TableData;
